import React from 'react';

const KolaborasiLembagaDanSekolah: React.FC = () => {
  return (
    <div className="text-justify py-4 space-y-4">
      <p className="mb-4">
        Membangun talenta teknologi berkelas dunia tidak dapat diserahkan semata-mata pada kurikulum formal di dalam ruang kelas sekolah. Diperlukan kolaborasi lintas sektor yang erat antara institusi pendidikan tinggi, lembaga pembina keahlian, dan industri teknologi untuk menghadirkan pengalaman belajar berbasis praktik nyata (<i>hands-on experience</i>).
      </p>

      <p className="mb-4">
        Kolaborasi strategis antara <b>Indonesia Innovative Technology (IIT)</b>, <b>Accelist Edukasi Indonesia (AEDU)</b>, <b>Teach for Indonesia (TFI)</b>, dan <b>Bina Nusantara Computer Club (BNCC)</b> menjadi contoh nyata bagaimana kemitraan edukatif mampu membuka akses pembelajaran coding, robotika, dan inovasi web bagi ribuan siswa di berbagai pelosok nusantara.
      </p>

      <h2 className="text-lg font-semibold text-gray-800 mt-6 mb-3">
        Tiga Manfaat Sinergi Triple-Helix Pendidikan
      </h2>
      <ul className="list-disc pl-6 mb-6 space-y-3">
        <li>
          <strong>Penyelarasan Standar Industri (Industry Alignment):</strong> Materi pelatihan dan kategori lomba disusun mengikuti tren teknologi terkini yang dibutuhkan dunia kerja profesional.
        </li>
        <li>
          <strong>Akses Mentorship Terbuka:</strong> Siswa SD, SMP, dan SMA mendapatkan bimbingan langsung dari mahasiswa berprestasi dan praktisi rekayasa perangkat lunak berpengalaman.
        </li>
        <li>
          <strong>Fasilitas dan Laboratorium Terpadu:</strong> Memberikan kesempatan bagi siswa sekolah mitra untuk menguji prototipe mereka menggunakan sarana laboratorium universitas yang lengkap.
        </li>
      </ul>

      <h2 className="text-lg font-semibold text-gray-800 mt-6 mb-3">
        Membuka Peluang Prestasi Internasional
      </h2>
      <p className="mb-4">
        Melalui ekosistem kolaboratif ini, para pemenang kompetisi nasional mendapatkan jalur pembinaan intensif dan kesempatan mewakili delegasi Indonesia di ajang kompetisi sains internasional, seperti ajang kompetisi robotika dan teknologi di Korea Selatan.
      </p>

      <p className="mb-4">
        Sinergi yang solid ini membuktikan bahwa ketika berbagai pihak bergandengan tangan demi masa depan generasi penerus, potensi anak bangsa dapat berkembang mekar tanpa batas.
      </p>
    </div>
  );
};

export default KolaborasiLembagaDanSekolah;
